import { createSlice, createAction } from "@reduxjs/toolkit";
import { target } from "glamor";

export const generateUpdateSourceTextAction = createAction("modelMT/generateUpdateSourceTextAction")

const initModel = {
  modelMT: {
    sourcelanguageCode: 0,
    targetLanguageId: 0,
    sourcelanguageCode: "",
    targetlanguageCode: "",
    putTargetOnError: true,
    semgments: [],
    engine: 0,
    isTrageLangSelected: false,
  },
  isUpdating: true,
};

export const translationModelSlice = createSlice({
  name: "modelMT",
  initialState: initModel,
  reducers: {
    updateModel: (state, action) => {
      state.modelMT.sourcelanguageCode = action.payload.sourcelanguageCode;
      state.modelMT.targetLanguageId = action.payload.targetLanguageId;
      state.modelMT.semgments = action.payload.text;
      state.isUpdating = false;
    },
    loadingModel: (state) => {
      state.isUpdating = true;
    },
    updateSourceLanguageId: (state, action) => {
      state.modelMT.sourcelanguageCode = action.payload.langCode;
      state.modelMT.sourceLanguageId = action.payload.langId;
    },
    updateTargetLanguageId: (state, action) => {
      //state.modelMT.targetLanguageId = action.payload;
      state.modelMT.sourcelanguageCode = action.payload;
      state.modelMT.isTrageLangSelected = true;
    },
    updateSourceText: (state, action) => {
      state.modelMT.semgments = action.payload.sourceText;
      state.modelMT.targetlanguageCode = action.payload.langCode;
      state.modelMT.targetLanguageId = action.payload.targetId;
      state.modelMT.isTrageLangSelected = true;
      state.isUpdating = false;
    },
  },
});

export const { updateModel, loadingModel, updateSourceLanguageId, updateTargetLanguageId, updateSourceText } = translationModelSlice.actions;

//export default translateReducer;
